import { render, staticRenderFns } from "./HotelsAvailability.vue?vue&type=template&id=2c99eabf&scoped=true&"
import script from "./HotelsAvailability.vue?vue&type=script&lang=ts&"
export * from "./HotelsAvailability.vue?vue&type=script&lang=ts&"
import style0 from "./HotelsAvailability.vue?vue&type=style&index=0&id=2c99eabf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c99eabf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c99eabf')) {
      api.createRecord('2c99eabf', component.options)
    } else {
      api.reload('2c99eabf', component.options)
    }
    module.hot.accept("./HotelsAvailability.vue?vue&type=template&id=2c99eabf&scoped=true&", function () {
      api.rerender('2c99eabf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Availability/view/vue/components/HotelsAvailability.vue"
export default component.exports